import { ReduxRootState } from "../types/redux-store";
import type { User } from "features/user";

type IRootState = ReduxRootState;

export const getPage = (state: IRootState) => state.common.page;
export const getUser = (state: IRootState | { user: Partial<User> }) =>
  state.user as User;
export const getUserPostStatuses = (state: IRootState) => {
  return state.user?.postStatuses && state.user?.postStatuses.length > 0
    ? state.user.postStatuses
    : [];
};
export const getUserPreferences = (state: IRootState) =>
  state.user?.preferences ?? {};
export const getUserCollaborators = (state: IRootState) =>
  state.user?.collaborators ?? [];
export const getUserCollaboratorAdmin = (state: IRootState) => {
  const collaborators = state.user?.collaborators ?? [];
  return collaborators.find((collaborator) => collaborator.role === "admin");
};
export const getLoading = (state: IRootState) => state.common.loading.isLoading;

type RoutineWithPrefix = { _PREFIX: string };

export const getRoutinesLoading = (
  state: IRootState,
  _routines: RoutineWithPrefix | RoutineWithPrefix[] = []
): boolean => {
  const loadingState = state.common.loading;

  // If empty array is supplied then nothing to do.
  if (!_routines || (Array.isArray(_routines) && _routines.length === 0)) {
    return false;
  }

  const routines = Array.isArray(_routines) ? _routines : [_routines];

  let isLoading = false;
  routines.forEach((routine) => {
    const prefix = routine._PREFIX;
    if (loadingState[prefix] === true) {
      isLoading = true;
    }
  });
  return isLoading;
};

// Pagination
export const getPagination = (state: IRootState) => state.pagination;
export const getPageSize = (state: IRootState) => state.pagination.pageSize;
export const getCurrentPage = (state: IRootState) =>
  state.pagination.currentPage;

// Modals
export const getModals = (state: IRootState) => state.modal.modals;
export const getModalsLoading = (state: IRootState) => state.modal.loading;
export const getLibsModals = (state: IRootState) =>
  state["@libs/modals"].openedModals;
